import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { DocumentState } from '../../../store/state/document.state';
import { FormsState } from '../../../store/state/pace-forms.state';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { ConfigService } from '@evorait/pace-core';
import { downloadDocuments, selectDocument } from '../../../store/actions/docBox.action';
import { faCheck, faChevronDown, faChevronRight, faCloudUploadAlt, faSave } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-forms-docbox-document-row',
    templateUrl: './docbox-document-row.component.html',
    styleUrls: ['./docbox-document-row.component.scss'],
})
export class DocBoxDocumentRowComponent {
    @Input()
    public document: DocumentState;

    @Output() public uploadDocForEntry = new EventEmitter<DocumentState>();

    public checkboxControl: FormControl;
    public formGroup: FormGroup;
    public enableIndividualDownload: boolean;
    public isExpanded = false;

    protected readonly faCloudUploadAlt = faCloudUploadAlt;
    protected readonly faCheck = faCheck;
    protected readonly faSave = faSave;
    protected readonly faChevronRight = faChevronRight;
    protected readonly faChevronDown = faChevronDown;
    public constructor(
        private readonly formBuilder: FormBuilder,
        private readonly store: Store<FormsState>,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly configService: ConfigService,
    ) {
        this.checkboxControl = formBuilder.control({ value: false, disabled: false });
        this.formGroup = formBuilder.group({
            checkbox: this.checkboxControl,
        });
        this.enableIndividualDownload = this.configService.getEnableIndividualDocBoxDownload();
    }

    public downloadDocument(): void {
        this.store.dispatch(downloadDocuments({ docBoxIds: [this.document.docBoxId] }));
    }

    public selectDocument(): void {
        this.store.dispatch(selectDocument({ docBoxId: this.document.docBoxId }));
    }

    public uploadForEntry(): void {
        this.uploadDocForEntry.next(this.document);
    }

    public toggleExpanded(): void {
        this.isExpanded = !this.isExpanded;
    }
}
